var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{staticClass:"form-control",attrs:{"type":"number","min":0},domProps:{"value":_vm.value},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }